export const SITE = {
  name: 'Unlistr',
  company: 'Rami Apps',
  supportEmail: 'unlistr@ramiapps.com',
  url: (import.meta.env.VITE_SITE_URL || 'https://unlistr.ramiapps.com').replace(/\/$/, ''),
  appUrl: import.meta.env.VITE_SHOPIFY_APP_URL || 'https://apps.shopify.com/unlistr',
};

export function absoluteUrl(path = '/') {
  return `${SITE.url}${path === '/' ? '' : path}`;
}

export const plans = [
  { name: '48-hour', interval: 'Every 48 hours', price: 'Free', featured: true },
  { name: 'Daily', interval: 'Every 24 hours', price: '$3/month' },
  { name: '12-hour', interval: 'Every 12 hours', price: '$6/month' },
  { name: '6-hour', interval: 'Every 6 hours', price: '$9/month' },
  { name: 'Hourly', interval: 'Every 1 hour', price: '$16/month' },
];
